export default __webpack_public_path__ + "static/logo-371cb6532b6977abd14909108cf0cab9.webp";